var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyInformation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "BedrijfsInformatie",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 41,
    viewBox: "0 0 32 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1016",
    "data-name": "Rectangle 1016",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0H27a5,5,0,0,1,5,5V41a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,1.5H27A3.5,3.5,0,0,1,30.5,5V39.5a0,0,0,0,1,0,0H1.5a0,0,0,0,1,0,0V5A3.5,3.5,0,0,1,5,1.5Z",
    fill: "none"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1017",
    "data-name": "Rectangle 1017",
    width: 8,
    height: 9,
    transform: "translate(18 30)",
    fill: "#000000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1018",
    "data-name": "Rectangle 1018",
    width: 8,
    height: 5,
    transform: "translate(18 22)",
    fill: "#000000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1023",
    "data-name": "Rectangle 1023",
    width: 8,
    height: 5,
    transform: "translate(6 22)",
    fill: "#000000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1024",
    "data-name": "Rectangle 1024",
    width: 8,
    height: 5,
    transform: "translate(6 30)",
    fill: "#000000"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1019",
    "data-name": "Rectangle 1019",
    width: 8,
    height: 5,
    transform: "translate(18 14)",
    fill: "#000000"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1022",
    "data-name": "Rectangle 1022",
    width: 8,
    height: 5,
    transform: "translate(6 14)",
    fill: "#000000"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1020",
    "data-name": "Rectangle 1020",
    width: 8,
    height: 5,
    transform: "translate(18 6)",
    fill: "#000000"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1021",
    "data-name": "Rectangle 1021",
    width: 8,
    height: 5,
    transform: "translate(6 6)",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyInformation);
export default __webpack_public_path__ + "static/media/CompanyInformation.d66e85101239ded7cacd87876d739633.svg";
export { ForwardRef as ReactComponent };